<template>
  <div class="h-full-half card hover:shadow-lg">
    <div class="h-full overflow-hidden">
      <div>
        <div class="relative" @click="go(item.id)">
          <img :src="$firstImage(item.images, 'small')" alt="" class="
                  img
                  rounded-t
                  object-center
                  h-15rem
                  object-cover
                  cursor-pointer
                " :onerror="defaultUrl" />
          <div class="status absolute z-10 inset-0 " v-if="item.status != 10 || !item.stock">
            <span class=" iconfont icon-yixiajia" v-if="item.status == 0"></span>

            <span class="iconfont icon-yishouqing" v-else-if="!item.stock"></span>
          </div>
        </div>
        <div class="h-full mx-2 mt-3  mb-2 flex flex-col items-start">
          <p class="font-bold text-base w-full name">
            <span class="cursor-pointer hover:(underline)" @click="go(item.id)">{{ item.name }}</span>
          </p>
        
          <p class=" space-x-3 truncate w-full flex">
            <span v-if="item.unitprice" class="flex is-center">{{ $p(item.unitprice) }}/{{$t("枝")}}<span class="single">{{$p(item.price)}}</span></span>
            <span v-else style="color: #FF4747 ">{{ $p(item.price) }}<span class="text-xs" style="color: #333333;">{{ $t('/扎起') }}</span></span>
            <span style="color:#909090 ;" class="text-xs">{{ $t('已售') }}{{ item.sales }}</span>
          </p>
          <p class="attrs">
            <span v-if="item.complete_attrs.color">{{ item.complete_attrs.color }}</span>
            <span v-if="item.complete_attrs.level">{{ item.complete_attrs.level }}</span>
            <span v-if="item.complete_attrs.norm">{{ item.complete_attrs.norm }}</span>
            <span v-if="item.complete_attrs.maturity">{{ item.complete_attrs.maturity }}</span>
            <span v-if="item.complete_attrs.length">{{ item.complete_attrs.length }}</span>
            <span v-if="item.complete_attrs.budsize">{{ item.complete_attrs.budsize }}</span>
          </p>
        </div>

        <!-- <div class="flex items-center ml-3 text-gray-400 text-sm cursor-pointer" @click="goSupplier">
          <el-link class="whitespace-nowrap overflow-hidden"> {{ $substring(item.supplier_info.name,10) }} <span class="iconfont icon-right"></span></el-link>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import { computed } from "@vue/composition-api"
export default {
  props: { item: Object },

  setup(props, ctx) {
    const defaultUrl =
      'this.src="' + require("@/assets/image/透明logo.png") + '"';

    const go = (id) => {
      ctx.root.$router.push({
        name: "ProductDetail",
        params: { id },
      });
    };
    const user = computed(() => ctx.root.$store.getters.user)
    // console.log("now_user:", user.value)
    const goSupplier = () => {
      if (!user.value.id) return ctx.root.$toast(ctx.root.$t('请先登录'))
      if (!user.value.user_lock_address) return ctx.root.$toast(ctx.root.$t('请先选择地址'))
      ctx.root.$goTo('/store/index?id=' + props.item.supplier_info.sid)
    }

    return { go, defaultUrl, goSupplier, user};
  },
};
</script>

<style scoped lang="scss">
@import "@/style/stl.scss";

.airlift {
  &::before {
    content: "空运：$ ";
  }
}

.tally {
  &::after {
    @apply text-xs;
    content: " /扎起";
  }
}

.h-full-half {
  // height: 375px;
  // min-height: 22.65rem;
  // height: 22rem;
  height: 100%;
}

.status {
  background-color: rgba(0, 0, 0, 0.4);
  color: #ffffff;
  @apply flex justify-center items-center;

  .iconfont {
    font-size: 4rem;
  }
}
.attrs{
  // overflow:hidden;
  width: 200px;
  display: flex;
  flex-wrap: wrap;
	word-wrap: break-word;
    &>span {
		font-size: 0.875rem;
		padding-right: 0.5rem;
		white-space: nowrap;
		}
}
.name {
  word-break: break-all;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  /* 这里是超出几行省略 */
  overflow: hidden;
}
.single {
  display: inline-block;
  height: 14px;
  padding: 0 5px 0 7px;
  font-size: 10px;
  line-height: 14px;
  color: #FFFFFF;
  margin-left: 4px;
  background-repeat: no-repeat;
  background-size: 100% 14px;
  background-image: url('https://cdn-qn.huaeb.com/sellmall/Uwm9/20240819/Ft3UvAmvjsKkwlIlBfinoTXmYQP6.png');

}
</style>
